import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import PropTypes from 'prop-types';
import classnames from 'classnames';
/**
 * Spinner - An indeterminate circular progress indicator.
 */

var Spinner =
/*#__PURE__*/
function (_Component) {
  _inherits(Spinner, _Component);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _possibleConstructorReturn(this, _getPrototypeOf(Spinner).apply(this, arguments));
  }

  _createClass(Spinner, [{
    key: "render",
    value: function render() {
      var className = this.props.className;
      var classes = classnames('woocommerce-spinner', className);
      return createElement("svg", {
        className: classes,
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg"
      }, createElement("circle", {
        className: "woocommerce-spinner__circle",
        fill: "none",
        strokeWidth: "5",
        strokeLinecap: "round",
        cx: "50",
        cy: "50",
        r: "30"
      }));
    }
  }]);

  return Spinner;
}(Component);

Spinner.propTypes = {
  /**
   * Additional class name to style the component.
   */
  className: PropTypes.string
};
export default Spinner;
//# sourceMappingURL=index.js.map